export const fortunesPt = [
  `Qualquer um pode admitir para si mesmo que estava errado, mas o homem sábio admite para os outros.`,
  `Um homem com um relógio sabe que horas são. Um homem com dois relógios nunca tem certeza.`,
  `Mentes pequenas são as primeiras a condenar grandes ideias.`,
  `Resistir à tentação é mais fácil quando você pensa que provavelmente terá outra chance.`,
  `Amigos não são feitos, apenas reconhecidos pela primeira vez.`,
  `Ame muitos, confie em poucos e sempre reme a sua própria canoa.`,
  `Nunca deixe para amanhã o que você pode evitar completamente.`,
  `É uma má ideia dar conselhos. Um homem sábio não vai precisar e um tolo não vai dar atenção.`,
  `Não faça algo simples e eficiente quando você pode fazê-lo complexo e maravilhoso.`,
  `É sempre melhor falhar fazendo algo do que ser excelente em não fazer nada.`,
  `De nada vale estar preparado para todas as emergências se está despreparado para a vida cotidiana.`,
  `Ninguém fica velho demais para aprender uma nova maneira de ser estúpido.`,
  `Viva cada dia como se fosse o último dia da sua vida, porque até agora é.`,
  `A gargalhada é um melhorador de humor sem efeitos colaterais.`,
  `Se você se esforçar muito para ser como outra pessoa, estará disperdiçando o tempo da pessoa que é.`,
  `Normalmente é mais fácil apontar um dedo do que oferecer uma mão amiga.`,
  `Se você não tem tempo para fazer certo da primeira vez, você precisa ter tempo para fazer de novo.`,
  `Amor verdadeiro é o triunfo da imaginação sobre a inteligência.`,
  `O dinheiro não traz felicidade, mas é mais confortável chorar em um Porsche do que numa bicicleta.`,
  `Se as pessoas falam negativamente sobre você, certifique-se que ninguém vai acreditar.`,
  `Trabalho árduo compensa no futuro, mas preguiça compensa agora.`,
  `A experiência é o pior professor. Sempre dá os testes primeiro e as instruções depois.`,
  `Se você não consegue aprender a fazer algo bem, aprenda a gostar de fazer mal.`,
  `Nostalgia é a constatação de que as coisas não eram tão ruins quanto pareciam na época.`,
  `A vida é como uma rifa. Você precisa estar presente para ganhar.`,
  `Ame seus vizinhos, mas não reitre a cerca.`,
  `Nunca tenha medo de fazer algo novo. Amadores construíram a arca, profissionais construíram o Titanic.`,
  `Algumas pessoas têm um grande círculo de amigos, enquanto outras têm apenas amigos de quem gostam.`,
  `Depois de tudo dito e feito, normalmente muito mais é dito do que feito.`,
  `Muitos se oferecem para carregar o banco quando é hora de mover o piano.`,
  `Se você não está vivendo no limite, está ocupando muito espaço.`,
  `Todas as generalizações são falsas - incluindo esta.`,
  `Sorte é apenas a desculpa do perdedor para a posição do vencedor.`,
  `Se você cair de cara no chão, pelo menos você está indo para a frente.`,
  `O tempo é um grande professor, mas eventualmente mata todos os seus alunos.`,
  `O que vai, volta. E então fica muito tonto e cai.`,
  `A pessoa que disse: 'coisas boas vêm para aqueles que esperam' provavelmente ainda está esperando.`,
  `Conselho para o sábio: não brinque de pular com um unicórnio.`,
  `Boas decisões vêm da experiência, e a experiência vem das más decisões.`,
  ,
  `A única pessoa que concluiu todo o seu trabalho até sexta-feira foi Robin Crusoé.`,
  `Ter o direito de fazer algo não significa que é certo fazê-lo.`,
  `Muitas pessoas pensam que estão pensando, mas na verdade estão apenas reorganizando seus preconceitos.`,
  `A má notícia é que o tempo voa. A boa notícia é: pelo menos você é o piloto.`,
  `Você não pode ter tudo.... Onde você colocaria?`,
  `Escolha seus amigos pelo caráter e suas meias pela cor, não o contrário.`,
  `Dinheiro é como estrume - não vale nada a menos que você o espalhe.`,
  `A única arma que se torna mais afiada com o uso constante é a língua.`,
  `Seja gentil com as pessoas indelicadas - elas são as que mais precisam.`,
  `A felicidade é muitas vezes o resultado de estar muito ocupado para ser infeliz.`,
  `Envelhecer é obrigatório. Crescer é opcional.`,
  `Assim que você faz algo à prova de idiotas, aparece um idiota maior.`,
  `Nunca sabemos o valor da água até que o poço esteja seco.`,
  `O maior prazer da vida é fazer aquilo as pessoas dizem que você nunca fará.`,
  `Uma falha não é um erro, a menos que você se recuse a corrigi-la.`,
  `Uma razão pela qual os computadores podem fazer mais trabalho do que as pessoas é que eles nunca precisam parar para atender o telefone.`,
  `Até os homens mais sábios gostam de um pouco de bobagem, de vez em quando.`,
  `É sempre mais fácil para um homem resolver o problema de outro.`,
  `Para cada problema complicado, há uma resposta simples, fácil de entender e errada.`,
  `Um pessimista vê dificuldade em cada oportunidade; um otimista vê oportunidade em cada dificuldade.`,
  `Muitas pessoas falam porque (e apenas porque) não sabem ficar em silêncio.`,
  `O avarento fica rico parecendo pobre, um homem extravagante fica pobre parecendo rico.`,
  `Um raio não cai toda vez que troveja.`,
  `Homem de palavras, mas não de ações, é um jardim sem flores, apenas com ervas daninhas.`,
  `Quanto mais difícil for o obstáculo, mais forte você será por enfrentá-lo.`,
  `Só pedimos conselhos quando já sabemos a resposta, mas não queríamos saber.`,
  `As palavras deveriam ser pesadas, não contadas.`,
  `Um mar calmo não faz um marinheiro habilidoso.`,
  `Se você chega em segundo lugar, você é o primeiro perdedor.`,
  `Se você não pode controlar o vento, ajuste a sua vela.`,
  `Se você pisa numa poça, não adianta culpar a poça.`,
  `Se você sempre faz o que sempre fez, sempre obterá o que sempre obteve.`,
  `Um minuto de silêncio é mais poderoso do que uma hora de discurso.`,
  `O diabo tem muitas ferramentas, mas a mentira é a alça que cabe em todas elas.`,
  `Um dos maiores erros da vida é viver como se temesse cometer erros.`,
  `A vida não consiste em ter boas cartas, mas em jogar bem aquelas você possui.`,
  `Nada torna uma pessoa mais produtiva do que a última hora.`,
  `Amar não é encontrar uma pessoa perfeita, é ver uma pessoa imperfeita perfeitamente.`,
  `Uma mentira fácil pode ser mais útil do que uma verdade complicada.`,
  `Se tudo o que você tem é um martelo, tudo parece um prego.`,
  `A única maneira de se ter um verdadeiro amigo é se tornar um.`,
  `A felicidade é o resultado da decisão de ser feliz.`,
  `Um pássaro na mão é mais seguro do que um voando.`,
  `Não existem atalhos para qualquer lugar que valha a pena ir.`,
  `Se você está disposto a admitir suas falhas, você tem uma falha a menos para admitir.`,
  `A melhor maneira de eliminar a tentação é sucumbir a ela!`,
  `Pessoas presunçosas nunca chegam a lugar nenhum, geralmente porque pensam que já estão lá.`,
  `Aquele que diz que algo não pode ser feito, nunca deve interromper aquele que está fazendo.`,
  `Os hábitos são como uma corda. Você adiciona um fio todos os dias, até que seja impossível cortá-lo.`,
  `Quando sua luz é mais forte, não fique nas sombras.`,
  `Aqueles que recebem o máximo da vida são os que mais dão.`,
  `Você não pode simplesmente chegar no topo da montanha. Primeiro, você tem que começar a escalar.`,
  `Idéias são coisas engraçadas. Elas não funcionarão a menos que você as implemente.`,
  `Pessoas felizes nem sempre têm o melhor, elas apenas aproveitam ao máximo o que têm.`,
  `Se você continuar fazendo o que está fazendo, continuará obtendo o que está obtendo.`,
  `Quando você concentra seus esforços, você faz do tempo o seu aliado.`,
  `Há momentos em que a única solução é fazer uma pausa.`,
  `Tudo é seu professor, se você estiver disposto a aprender.`,
  `Alguns dias você é o pombo, alguns dias você é a estátua.`,
  `Os líderes veem mais nas pessoas do que em si próprios.`,
  `Você não pode ordenhar uma vaca que você não tem.`,
  ,
  `Quem disse  que 'não importa se você ganha ou perde', provavelmente perdeu.`,
  `Maus hábitos são como uma cama confortável: fácil de entrar, difícil de sair.`,
  `É fácil ser corajoso a uma distância segura.`,
  `Conhecimento é perceber que a rua é de sentido único, mas sabedoria é olhar em ambas as direções de qualquer forma.`,
  `Se você vir uma tartaruga em um poste de cerca, ela teve alguma ajuda para chegar lá.`,
  `Ame seus inimigos. Isso vai deixá-los absolutamente loucos.`,
  `Cada carvalho começou como um par de nozes que decidiram se manter firmes.`,
  `As águias podem voar alto, mas as doninhas não são sugadas por motores de jatos`,
  `O único substituto para a falta de educação são bons reflexos.`,
  `Todos nós podemos aprender uma lição com o tempo. Ele não dá atenção às críticas.`,
  `Se você tiver que pedir dinheiro emprestado, encontre um pessimista - pelo menos ele não o esperará receber de volta.`,
  `O corpo humano foi projetado de tal forma que não podemos dar tapinhas nas próprias costas nem nos chutar com muita facilidade.`,
  `Até um porco cego em uma nevasca encontra um grão de vez em quando.`,
  `Precisar de alguém é como precisar de um paraquedas. Se ele não estiver lá da primeira vez, é provável que você não precise dele novamente.`,
  `Autoridade é uma pessoa que pode lhe dizer mais do que você realmente gostaria de saber sobre algo.`,
  `O tempo voa como uma flecha. A fruta voa como uma banana.`,
  `As pessoas que normalmente dão conselhos são as piores pessoas de quem se pode receber conselhos.`,
  `Se não fosse pela última hora, nada seria feito.`,
  `Não vá bater à porta da morte. Apenas toque a campainha e corra. Ela odeia isso.`,
  `Ninguém gosta de um sabichão... especialmente outro sabichão.`,
  `O pássaro madrugador pode pegar o verme, mas é o segundo rato que pega o queijo.`,
  `O melhor lugar para encontrar uma mão amiga é na ponta do seu braço.`,
  `É melhor ser um ninguém que realiza algo do que alguém que não realiza nada.`,
  `Uma consciência limpa faz um travesseiro macio.`,
  `Se você não tem coragem para começar, você já terminou.`,
  `Se você ama o que faz, você nunca trabalhará na sua vida.`,
  `Se você seguir o conselho de outras pessoas, você cometerá os erros de outras pessoas.`,
  `Se você não é o líder dos cães de trenó, o mundo parece praticamente o mesmo todos os dias.`,
  `Para alcançar uma grande altura, uma pessoa precisa ter grande profundidade.`,
  `Muitas pessoas, quando param para pensar, esquecem que têm de começar de novo.`,
  `De uma maneira geral, ninguém está ouvindo... até que você comete um erro.`,
  `Com mentiras você pode progredir no mundo, mas você nunca pode voltar.`,
  `Se você acertar todas as vezes, ou o alvo está muito próximo ou é muito grande.`,
  `O homem é o único animal que cora - ou que precisa.`,
  `Se você examinar o seu problema de perto, poderá ver que você faz parte dele.`,
  `Tente esquecer algo novo todos os dias.`,
  `Mesmo se você tentar viver cada dia de cada vez, às vezes eles te atacam todos de uma vez.`,
  `O sucesso vem do poder, o fracasso da impotência.`,
  `Diga palavras curtas e doces, caso você precise engoli-las.`,
  `Pessoas e tartarugas são muito parecidas: nenhuma vai muito longe sem arriscar o pescoço.`,
  `Você é o que você come, então fique longe do frango idiota.`,
  `A vida é como um rolo de papel higiênico. Quanto mais perto você chega do fim, mais rápido ele vai.`,
  `As pessoas parecem ficar nostálgicas sobre muitas coisas que não gostaram tanto da primeira vez.`,
  `Em caso de dúvida. . . murmure.`,
  `Você pode não ter o que é preciso para terminar, mas provavelmente tem o que é necessário para começar.`,
  `Muitas pessoas são como bolhas: elas não aparecem até que o trabalho esteja concluído.`,
  `A coisa mais fácil de ser é ser você mesmo.`,
  `Num coração cheio há espaço para tudo. Em um coração vazio, não há espaço para nada.`,
  `É melhor ter vivido um dia como um leão do que viver mil anos como uma ovelha.`,
  `Tenha cuidado ao esticar a verdade - eventualmente ela vai se voltar contra você.`,
  `Tédio é  sinal de potencial não utilizado.`,
  `Viver no colo do luxo é bom, até que o luxo se levante e vá embora.`,
  `Quanto mais você faz, mais você será capaz de fazer.`,
  `É melhor ter um inimigo fraco do que um amigo forte.`,
  `É difícil deixar a sua pegada se você passa o tempo todo sentado.`,
  `Algumas pessoas sonham alto, outras realizam na vida real.`,
  `Quando você se envolve com porcos, deve esperar ficar sujo.`,
  `Se você quer sempre ter a última palavra, peça desculpas.`,
  `Lembre-se sempre que você é único, assim como todo mundo.`,
  `Sucesso é uma jornada, não um destino.`,
  `Não é a felicidade que nos torna gratos, mas a gratidão que nos faz felizes.`,
  `O boato de que não tem uma perna para se sustentar vai encontrar outra maneira de se manter.`,
  `Para que suas palavras sejam absorvidas, elas devem ser sussurradas, não gritadas.`,
  `As pessoas não resistem à mudança, elas resistem serem mudadas.`,
  `Quando elefantes lutam, apenas a grama se machuca.`,
  `Você só é jovem uma vez, mas pode ser imaturo a vida inteira`,
  `Uma curva na estrada não é o fim da estrada, a menos que você não faça a curva.`,
  `Hoje é um dia de decisões firmes! ... Ou é??`,
  `Pessoas que dizem que não permitem que pequenas coisas os incomodem nunca tentaram dormir em um quarto com um mosquito.`,
  `O forte tira do fraco, mas o inteligente tira do forte.`,
  `Apenas certifique-se de que a luz no fim do túnel não é um trem se aproximando.`,
  `Existem duas razões para se fazer algo: uma razão realmente boa e a razão real.`,
  `Quanto mais velho fica um homem, mais longe ele tem que andar para a escola quando menino.`,
  `As únicas pessoas com quem você deve tentar se igualar são aquelas que o ajudaram.`,
  `Uma cachoeira é na verdade apenas um monte de gotas trabalhando juntas.`,
  `Um navio no porto está seguro, mas não é para isso que navios foram construídos.`,
  `Um pavão que se senta em sua cauda é apenas mais um peru.`,
  `Se o lobo não estiver à sua porta, não vá procurá-lo e convidá-lo para entrar.`,
  `A melhor maneira de esquecer todos os seus problemas é usar sapatos apertados.`,
  `Planeje ser espontâneo amanhã.`,
  `É melhor ficar em silêncio e deixá-los pensar que você é um tolo, do que abrir a boca e provar isso.`,
  `Dinheiro não é tudo, mas está muito à frente de tudo o que está em segundo lugar.`,
  `Um dia sem sol é... noite.`,
  `Quanto mais cedo você ficar para trás, mais tempo terá para alcançar.`,
  `Não se sinta mal. Metade das pessoas que você conhece está abaixo da média.`,
  `Se você acha que uma fraqueza pode ser transformada em algo positivo, isso é outra fraqueza.`,
  `Não fuja de seus medos - quando eles te alcançarem, você estará muito cansado para lutar.`,
  `A cada novo amanhecer, há uma nova oportunidade. Mas a cada pôr do sol, você estragou tudo de novo.`,
  `Lembre-se de que a dor é a maneira que natureza tem de lembrá-lo de quem está no comando.`,
  `Se você não aguenta o calor, não atice o dragão.`,
  `Você nunca sabe o que pode ficar sem até tentar.`,
  `Aqueles que vivem pela espada... são baleados por aqueles que vivem pela arma.`,
  `Um cachorro dentro de um canil late para as suas pulgas. Um cachorro ao ar livre caçando, nem as percebe.`,
  `Um palpite é a sua criatividade tentando lhe dizer algo.`,
  `Errar é humano. Também é humano culpar outra pessoa.`,
  `O problema de fazer algo certo da primeira vez é que ninguém percebe como foi difícil.`,
  `Somente aqueles que não esperam nada nunca são desapontados.`,
  `Mire na lua. Se não acertar, pelo menos você estará entre as estrelas.`,
  `Sutileza é a arte de dizer o que você pensa e sair do caminho antes de ser compreendido.`,
  `A maioria de nós é muito boa em cumprir promessas aos outros e péssima em cumprir promessas a nós mesmos.`,
  `Peça perdão hoje! Amanhã você pode não se sentir tão culpado.`,
  `Não tenha uma batalha de inteligência com um oponente desarmado.`,
  `Se a princípio você não conseguir, esconda todas as evidências de que tentou.`,
  `Não use uma palavra grande quando uma palavra diminuta for o suficiente.`,
  `Experiência é algo que você obtém só depois de precisar.`,
  `Viva cada dia como se fosse o último. Um dia desses, você estará certo.`,
  `As pessoas se preocupariam menos com o que os outros pensam delas se soubessem o quão raramente isso acontece.`,
  `Nada melhora tanto a sua memória quanto tentar esquecer.`,
  `A diferença entre genialidade e estupidez é que a genialidade tem limites.`,
  `O sucesso é como um carrinho de mão. Nada acontece a menos que você comece a empurrar.`,
  `A pessoa que diz que algo não pode ser feito não deve interromper a pessoa que está fazendo.`,
  `A folha de grama mais alta é a primeira a ser cortada pela máquina.`,
  `Pequenas bobagens de vez em quando são apreciadas pelos homens mais sábios.`,
  `Quando você está em águas profundas, é uma boa ideia manter a boca fechada.`,
  `Seja consistente, mas não o tempo todo.`,
  `A maneira mais rápida de dobrar seu dinheiro é dobrá-lo ao meio e colocá-lo de volta no seu bolso.`,
  `A melhor maneira de encontrar algo que você perdeu é substitui-lo`,
  `Pessoas responsáveis enfrentam a música, mesmo quando odeiam a melodia.`,
  `Navio em mar calmo não vai longe.`,
  `Faça uma pergunta estúpida, pareça um idiota por cinco minutos. Não faça perguntas, pareça um idiota para sempre.`,
  `Você só é jovem uma vez, mas com prática, pode ser imaturo para o resto da vida.`,
  `Não pense que não há crocodilos só porque a água está calma.`,
  `Cuidado: Às vezes, a luz no final do túnel diz SEM SAÍDA.`,
  `Em boca fechada não entra mosca.`,
  `Peça dinheiro emprestado a um pessimista: ele não espera que você o pague de volta.`,
  `Confiança é o sentimento que você tem antes de entender a situação.`,
  `Um erro não se justifica… mas concerta-se.`,
  `Contentamento não é conseguir tudo o que você quer, é perceber que você já tem.`,
  `Duas coisas que são difíceis de lidar com elegância: fracasso e sucesso.`,
  `A verdadeira grandeza das pessoas é revelada pela forma como tratam aqueles que não podem lhes fazer um favor.`,
  `Uma pessoa presunçosa nunca chega a lugar nenhum, ela sempre tem certeza de que já está lá.`,
  `Um bom relacionamento é como uma caçarola - apenas aqueles que fazem acontecer sabem exatamente o que há nela.`,
  `Uma consciência limpa é sinal de uma memória fraca.`,
  `Astrônomos dizem que o universo é finito... o que é um pensamento reconfortante para aquelas pessoas que não conseguem encontrar suas chaves.`,
  `Uma gravata limpa com certeza atrairá a sopa do dia.`,
  `Se você está chateado com o que não tem, você vai desperdiçar o que tem.`,
  `Consciente é quando você está ciente de algo. Consciência é quando você gostaria de não estar.`,
  `Conte sua idade com amigos, não com anos.`,
  `Uma pessoa é quase tão grande quanto as coisas que a deixam com raiva.`,
  `A preocupação dá à uma coisa pequena uma grande sombra.`,
  `A preocupação é como uma cadeira de balanço. Você acaba despendendo muito esforço e não chega a lugar nenhum.`,
  `Um computador pode ser capaz de vencê-lo no xadrez... mas provavelmente não no kickboxing.`,
  `Você nunca descobrirá novos oceanos a menos que esteja disposto a perder a vista da costa.`,
  `Um pássaro na mão é muito mais confuso do que dois na mata.`,
  `Há uma grande diferença entre conhecimento e inteligência.`,
  `Nada torna um peixe maior do que quase ser capturado.`,
  `Regra geral, ninguém ouve... até que você cometa um erro.`,
  `Uma desculpa ruim é melhor do que nenhuma.`,
  `Uma boa mentira tem mais crentes do que uma verdade ruim.`,
  `É melhor perguntar duas vezes do que perder o rumo uma vez.`,
  `A maneira mais eficaz de parecer sábio é ficar em silêncio.`,
  `Se você chegar ao fim de sua corda, dê um nó nela e segure-se.`,
  `Torne sua casa limpa o suficiente para ser saudável e bagunçada o suficiente para ser feliz.`,
  `Em reuniões, pense cuidadosamente sobre a frequência com que você menciona algo. Certifique-se de reservar sua participação para os pontos que você considera MAIS importantes.`,
  ,
  `O estábulo desgasta um cavalo mais do que a estrada.`,
  `Algumas pessoas têm tato, outros dizem a verdade.`,
  `A inveja atira nos outros, mas atinge a si mesma.`,
  `Mau hálito é melhor do que hálito nenhum.`,
  `Se não houvessem tolos no mundo, todas as pessoas concordariam em tudo.`,
  `A oportunidade sempre bate no momento menos oportuno.`,
  `Paciência é a arte de esconder sua impaciência.`,
  `Pessoas que dizem 'eu não jogo' estão jogando.`,
  `A maneira mais rápida de encontrar algo que você perdeu é substitui-lo.`,
  `A cana mais fina se curva com o vento, enquanto o carvalho mais alto... faz muitos móveis excelentes.`,
  `O segredo do sucesso é saber a quem culpar pelos seus fracassos.`,
  `A confiança é conquistada apenas após muitas ações, mas pode ser perdida com apenas uma.`,
  `Uma mente aberta e uma boca fechada fazem uma combinação feliz.`,
  `A beleza está nos olhos de quem vê, ou então é apenas aquela gosma matinal ou algo assim.`,
  `Não se preocupe com coisas mesquinhas.`,
  `A eficiência nada mais é do que uma preguiça inteligente.`,
  `Uma migalha da mesa do vencedor é melhor do que um banquete na mesa do perdedor.`,
  `E se não houvessem situações hipotéticas?`,
  `Quando seus grandes sonhos viraram pó, é hora de encontrar o aspirador.`,
  `Por que é que quando o piano precisa ser movido, todos correm para agarrar o banquinho?`,
  `Você não é quem você pensa que é, você não é quem eles pensam que você é, mas você poderia ser o que você pensa que eles pensam que você é.`,
  `O objetivo da ciência é construir melhores ratoeiras. O objetivo da natureza é construir melhores ratos.`,
  `O segredo do sucesso é descobrir quem culpar por seus fracassos.`,
  `O pior biscoito é melhor do que a melhor couve-de-bruxelas`,
  `Há dois tipos de pessoas no mundo: doadores e recebedores. Os recebedores comem melhor, mas os doadores dormem melhor.`,
  `Não desperdice lágrimas frescas com dores antigas.`,
  `Quando o seu trabalho fala por si mesmo, tente não interrompê-lo.`,
  `Um bom susto é mais útil do que um bom conselho.`,
  `Pessoas que guardam suas opiniões para si mesmas raramente estarão erradas.`,
  `Você não pode descobrir novos oceanos a menos que esteja disposto a perder a vista do cais.`,
  `Você precisa saber o suficiente para saber que não sabe o suficiente.`,
  `Os planos mais bem elaborados entre ratos e homens... geralmente envolvem queijo.`,
  `Se você não consegue rir de si mesmo, pode estar perdendo a piada do século.`,
  `Você não pode controlar o vento, mas pode ajustar a sua vela.`,
  `Fé é o pássaro que sente a luz e canta enquanto o amanhecer ainda está escuro.`,
  `A generosidade se recompensará mais cedo do que você imagina.`,
  `Os tolos usam o amanhã. Os sábios usam o hoje.`
]
